import { config } from '@iheartjane/config';
import type { StoreType } from '@iheartjane/types';

import { request } from '@jane/monolith/utils/request';

const url = (id: string | number) => `${config.apiPath}/operators_stores/${id}`;

export const OperatorStoresSource = {
  get(id: string | number, params: RequestInit & { requireAuth?: boolean }) {
    return request(
      url(id),
      {
        method: 'GET',
      },
      params
    );
  },

  getAvailableFufillmentModes({
    id,
    lat,
    long,
    medOrRec,
    productId,
  }: {
    id: string | number;
    lat?: number;
    long?: number;
    medOrRec?: Exclude<StoreType, 'all'>;
    productId?: number | null;
  }) {
    const url = `${config.apiPath}/operators_stores/`;
    return request(
      url,
      {
        method: 'GET',
      },
      {
        operator_id: id,
        med_rec: medOrRec,
        lat,
        long,
        product_id: productId,
      }
    );
  },
};
